import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "role-skill-card"
};
const _hoisted_2 = {
  key: 0,
  class: "skill-container"
};
const _hoisted_3 = {
  key: 0,
  class: "path-desc"
};
const _hoisted_4 = {
  class: "skilled-box"
};
const _hoisted_5 = {
  key: 0,
  class: "skilled-path"
};
const _hoisted_6 = {
  key: 0,
  class: "separator"
};
const _hoisted_7 = {
  key: 1,
  class: "over-limit-box"
};
const _hoisted_8 = {
  class: "over-limit-path"
};
const _hoisted_9 = {
  class: "probability-desc"
};
const _hoisted_10 = {
  key: 6,
  class: "increase-box"
};
const _hoisted_11 = {
  class: "increase-skill-item",
  style: {
    "flex": "1"
  }
};
const _hoisted_12 = {
  class: "increase-skill-item"
};
import { ref, computed } from 'vue';
import { ElButton, ElInputNumber, ElMessage, ElProgress, ElRow } from 'element-plus';
import { inApostleType, isValid, parseToCostDesc, getPercentage, isAdminType, isUserType } from '@/tools/utils';
import { request } from '@/manager/net_manager';
import store from '@/store';
import 'element-plus/es/components/progress/style/css'; // constants

export default {
  __name: 'RoleSkillCard',
  props: {
    roleId: {
      type: [String, Number],
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  emits: ['update', 'edit'],

  setup(__props, {
    emit: __emit
  }) {
    const colors = [{
      color: '#f56c6c',
      percentage: 20
    }, {
      color: '#e6a23c',
      percentage: 40
    }, {
      color: '#5cb87a',
      percentage: 60
    }, {
      color: '#1989fa',
      percentage: 80
    }, {
      color: '#6f7ad3',
      percentage: 100
    }]; // pre-declaration

    const props = __props;
    const emits = __emit; // refs

    const message = ref(null);
    const increaseValue = ref(0); // computed

    const userType = computed(() => {
      return store.state.user ? parseInt(store.state.user.user_type) : 4;
    });
    const assignablePoint = computed(() => {
      return store.state.role_info[props.roleId]?.skill_point ?? 0;
    });
    const increaseEnable = computed(() => {
      if (assignablePoint.value <= 0) return false;
      if (props.data.probability_grow === 0) return false;
      return props.data.max_value > props.data.probability;
    });
    const increaseMaxValue = computed(() => {
      const maxValue = Math.ceil((props.data['max_value'] - props.data['probability']) / props.data['probability_grow']);
      return Math.min(maxValue, assignablePoint.value);
    }); // functions

    const getSkillDesc = item => {
      const sectsName = item.sects.name;
      const isPrivate = item.is_private ? '秘传' : '';
      const degreeLevel = `${item.degree}级`;
      const skillType = isValid(item.skill_type) ? item.skill_type.desc : '不明';
      const conventional = item.conventional ? '常规施法' : '构筑施法';
      const powerType = isValid(item.power_type) ? item.power_type.desc : '不明';
      let skillDesc = `${sectsName} · ${degreeLevel}${isPrivate} · ${powerType} · ${skillType} · ${conventional}`;

      if (inApostleType(userType.value)) {
        return `${skillDesc} · 神秘${item.mysterious_level}`;
      }

      return skillDesc;
    };

    const getSkillProbabilityDesc = () => {
      let maxValue = props.data.probability_limit.toString();

      if (props.data.probability_limit !== props.data.max_value) {
        maxValue = `${props.data.probability_limit} -> ${props.data.max_value}`;
      }

      return `成功率（基准： ${props.data.probability_base}；成长： ${props.data.probability_grow}；上限： ${maxValue}）`;
    };

    const enhanceSkill = () => {
      if (message.value) {
        message.value.close();
      }

      request('skills/role_skills/increase/', {
        'role_skill_id': props.data['id'],
        'increase_value': increaseValue.value
      }, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        store.commit('update_role_info', {
          role_id: props.roleId,
          key: 'skill_point',
          value: assignablePoint.value - increaseValue.value
        });
        emits('update');
        increaseValue.value = 0;
        message.value = ElMessage.success({
          message: '精进完成',
          duration: 1500
        });
      });
    };

    const editRoleSkill = () => {
      emits('edit', props.data);
    }; // const getData = () => {
    //   request('skills/get_role_skill/', {'skill_id': props.skill['id']}, 'POST').then(response => {
    //     // console.log(`${props.skill['id']}是${response.data.name}`)
    //     if (response.code === 0) {
    //       data.value = response.data
    //     }
    //   })
    // }
    // lifecycle
    // onMounted(() => {
    //   data.value = props.skill
    // })


    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), __props.data ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [_createElementVNode("text", null, [_createElementVNode("b", null, _toDisplayString(getSkillDesc(__props.data)), 1)])]),
        _: 1
      }), _createVNode(_unref(ElRow), {
        class: "skill-desc-row"
      }, {
        default: _withCtx(() => [__props.data.skilled_path || __props.data.over_limit_path ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [__props.data.skilled_path ? (_openBlock(), _createElementBlock("text", _hoisted_5, " 专精途径：" + _toDisplayString(__props.data.skilled_path), 1)) : _createCommentVNode("", true)]), __props.data.over_limit_path ? (_openBlock(), _createElementBlock("text", _hoisted_6, "/")) : _createCommentVNode("", true), __props.data.over_limit_path ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("text", _hoisted_8, " 超限途径：" + _toDisplayString(__props.data.over_limit_path), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
        _: 1
      }), increaseEnable.value ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0,
        class: "skill-desc-row",
        style: {
          "justify-content": "flex-start"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("text", _hoisted_9, _toDisplayString(getSkillProbabilityDesc()), 1)]),
        _: 1
      })) : _createCommentVNode("", true), increaseEnable.value ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 1,
        class: "progress-container"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElProgress), {
          color: colors,
          percentage: _unref(getPercentage)(__props.data.probability, __props.data.max_value),
          "show-text": false,
          "stroke-width": 6,
          class: "skill-progress"
        }, null, 8, ["percentage"])]),
        _: 1
      })) : _createCommentVNode("", true), _unref(isValid)(__props.data.timing_type) ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 2,
        class: "skill-desc-row"
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, [_cache[2] || (_cache[2] = _createTextVNode("发动时机    ", -1)), _createElementVNode("b", null, _toDisplayString(__props.data.timing_type.desc), 1)])]),
        _: 1
      })) : _createCommentVNode("", true), _unref(isValid)(__props.data.cooldown) ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 3,
        class: "skill-desc-row"
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, [_cache[3] || (_cache[3] = _createTextVNode("技能冷却    ", -1)), _createElementVNode("b", null, _toDisplayString(__props.data.cooldown.desc), 1)])]),
        _: 1
      })) : _createCommentVNode("", true), _unref(isValid)(__props.data.cost) ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 4,
        class: "skill-desc-row"
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, [_cache[4] || (_cache[4] = _createTextVNode("技能消耗    ", -1)), _createElementVNode("b", null, _toDisplayString(_unref(parseToCostDesc)(__props.data['cost'])), 1)])]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_unref(ElRow), {
        class: "skill-desc"
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(__props.data['desc']), 1)]),
        _: 1
      }), _unref(isValid)(__props.data.deep_desc) ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 5,
        class: "skill-deep-desc"
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(__props.data['deep_desc']), 1)]),
        _: 1
      })) : _createCommentVNode("", true), _unref(isUserType)(userType.value) && increaseEnable.value ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_unref(ElInputNumber), {
        modelValue: increaseValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => increaseValue.value = $event),
        max: increaseMaxValue.value,
        min: 0
      }, null, 8, ["modelValue", "max"])]), _createElementVNode("div", _hoisted_12, [_createVNode(_unref(ElButton), {
        disabled: increaseValue.value === 0,
        onClick: _cache[1] || (_cache[1] = $event => enhanceSkill(__props.data))
      }, {
        default: _withCtx(() => [_createTextVNode(" 技能精进（" + _toDisplayString(increaseValue.value === 0 ? assignablePoint.value : `${assignablePoint.value} - ${increaseValue.value}`) + "） ", 1)]),
        _: 1
      }, 8, ["disabled"])])])) : _createCommentVNode("", true), _unref(isAdminType)(userType.value) ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 7,
        class: "apostle-operator-row"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElButton), {
          onClick: editRoleSkill
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" 角色技能调整 ", -1)]))]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
    };
  }

};